export function scrollToElement(element: HTMLElement|null, scrollToTop: boolean = false) {
    if (element === null) {
        return;
    }
    const elementRect = element.getBoundingClientRect();
    let scrollPosition = elementRect.top;
    if (!scrollToTop) {
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        scrollPosition = absoluteElementTop - (window.innerHeight / 2);
    }
    window.scroll({
        top: scrollPosition,
        left: 0,
        behavior: 'smooth'
    });
}
